export default [
  {
    question:
      "Which of the following titles was the first to be shown when TG4 launched back in 1996?",
    answers: ["Ros na Rún", "Draíocht", "Nuacht TG4"],
    correct: [1],
    selected: false,
  },
  {
    question: "Where is TG4 based?",
    answers: ["Connemara", "Dingle", "Donegal"],
    correct: [0],
    selected: false,
  },
  {
    question:
      "What did Yu Ming do before he came to Ireland in the film Yu Ming is Ainm Dom?",
    answers: [
      "Learnt to speak Irish",
      "Learnt to speak English  ",
      "Learnt how to play the fiddle",
    ],
    correct: [0],
    selected: false,
  },
  {
    question:
      "Which of these famous faces once made an appearance in an episode of Ros na Rún?",
    answers: ["Stephen Fry", "David Williams", "Daniel O’Donnell"],
    correct: [0, 2],
    selected: false,
  },
  // q5
  {
    question:
      "Which previous TG4 weather presenter pranked the audience by pretending they were struck by lightning while live?",
    answers: ["Orla Ní Fhinneadha ", "Dáithí Ó Sé", "Caitlín Nic Aoidh"],
    correct: [2],
    selected: false,
  },
  // q6
  {
    question: "Which team did TG4’s Underdogs beat in 2004?",
    answers: ["Kerry", "Mayo", "Dublin"],
    correct: [0],
    selected: false,
  },
  // q7
  {
    question:
      "What was the name of Aifric’s best friend in the teenage drama series Aifric?",
    answers: ["Máire", "Claudia", "Sophie"],
    correct: [2],
    selected: false,
  },
  {
    question: "Which of the following was not a presenter on Paisean Faisean?",
    answers: ["Síle Seoige", "Maura Derrane", "Aoife Ní Thuairisg"],
    correct: [1],
    selected: false,
  },
  // q9
  {
    question:
      "On which of these TG4 shows were we first introduced to Hector Ó hEochagáin?",
    answers: ["Hanging with Hector", "Amú ", "Only Fools Buy Horses"],
    correct: [1],
    selected: false,
  },
  {
    question: "Who won Feirm Factor in 2009?",
    answers: [
      "Tom MacGillycuddy from Co Kerry",
      "Gavin Satchwell from Co Kildare",
      "Caroline O’Neill from Co Cork",
    ],
    correct: [0],
    selected: false,
  },
];
